import { render, staticRenderFns } from "./GetPrivateGroup.vue?vue&type=template&id=6c44677b&scoped=true&"
import script from "./GetPrivateGroup.vue?vue&type=script&lang=js&"
export * from "./GetPrivateGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c44677b",
  null
  
)

export default component.exports